import React from 'react'

import {
  Button,
  ButtonColorVariant,
  LoadingSpinner as Loading,
} from '@gousto-internal/citrus-react'
import Link from 'Link'
import classnames from 'classnames'

import routes from 'config/routes'

import { useRecommendedRecipes } from '../../hooks/useRecommendedRecipes'
import { SeeMenuSection } from './SeeMenuSection'

import orderCss from '../Order/Order.css'
import css from './NoOrders.css'

export const NoOrders = () => {
  const { recipes, isLoading } = useRecommendedRecipes()

  if (isLoading) {
    return (
      <div className={css.spinner}>
        <Loading />
      </div>
    )
  }

  return (
    <div>
      <div className={orderCss.orderWrap}>
        <div className={classnames(orderCss.order, css.noShadow)}>
          <p className={css.messageCopy}>You have no upcoming deliveries</p>
        </div>
      </div>
      <div className={orderCss.orderWrap}>
        <div className={orderCss.order}>
          <div>
            <p className={css.twrCopy}>Check out a selection of this week&apos;s menu</p>
          </div>
          <div>
            <SeeMenuSection recipes={recipes} />
          </div>
          <div className={css.buttonRow}>
            <Link to={`${routes.client.menu}`} clientRouted={false}>
              <Button colorVariant={ButtonColorVariant.Secondary}>See full menu</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
